/**
 * Sprint S-8 · Sentry init (opcional). Solo activa si REACT_APP_SENTRY_DSN
 * está definida. En su ausencia, no carga nada y la app sigue funcionando.
 */
import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;
// Detección automática de entorno por hostname; el .env puede forzarlo.
function detectEnv() {
  try {
    const host = (typeof window !== "undefined" && window.location?.hostname) || "";
    if (host === "ag-ecosystem.com" || host.endsWith(".ag-ecosystem.com")) return "production";
    if (host.includes("preview.emergentagent.com")) return "preview";
    if (host === "localhost" || host === "127.0.0.1") return "local";
  } catch (_) { /* SSR / no-window */ }
  return "preview";
}
const ENV = process.env.REACT_APP_SENTRY_ENV || detectEnv();

let inited = false;

export function initSentry() {
  if (inited || !DSN) return;
  try {
    Sentry.init({
      dsn: DSN,
      environment: ENV,
      tracesSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0,
    });
    inited = true;
  } catch (e) {
    // ignore
  }
}

export function reportError(err, context = {}) {
  if (!inited) return;
  try { Sentry.captureException(err, { extra: context }); } catch {}
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
